export const RESERVED_BROKER_ENV_VAR_NAMES = new Set([
  'ALPACA_API_KEY',
  'ALPACA_API_SECRET',
  'ALPACA_OAUTH_TOKEN',
  'ALPACA_IS_PAPER',
  'TRADIER_ACCOUNT_NUMBER',
  'TRADIER_ACCESS_TOKEN',
  'TRADIER_API_KEY',
  'TRADIER_TOKEN',
  'TRADIER_REFRESH_TOKEN',
  'TRADIER_OAUTH_CLIENT_ID',
  'TRADIER_OAUTH_CLIENT_SECRET',
  'TRADIER_IS_PAPER',
  'SCHWAB_ACCOUNT_NUMBER',
  'SCHWAB_TOKEN',
  'KRAKEN_API_KEY',
  'KRAKEN_API_SECRET',
  'COINBASE_API_KEY_NAME',
  'COINBASE_PRIVATE_KEY',
  'COINBASE_API_PASSPHRASE',
  'COINBASE_SANDBOX',
  'WEEX_API_KEY',
  'WEEX_API_SECRET',
  'WEEX_API_PASSPHRASE',
  'BITUNIX_API_KEY',
  'BITUNIX_API_SECRET',
  'BITUNIX_TRADING_MODE',
]);

export function getReservedBrokerEnvVarNames(keyNames = []) {
  return keyNames
    .map((key) => String(key || '').trim().toUpperCase())
    .filter((key) => RESERVED_BROKER_ENV_VAR_NAMES.has(key));
}

export function hasReservedBrokerEnvVarName(keyNames = []) {
  return getReservedBrokerEnvVarNames(keyNames).length > 0;
}
